import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const TabButton = ({
  anchor,
  isVisible,
  onClick,
  title,
}) => (
  <button
    type="button"
    className={`tab__button${isVisible ? ' tab__button-selected' : ''}`}
    id={anchor}
    onClick={onClick}
  >
    <span className="tab__button-text">
      {title}
    </span>
  </button>
);

TabButton.propTypes = {
  anchor: PropTypes.string.isRequired,
  isVisible: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

TabButton.defaultProps = {
  isVisible: false,
};

export default TabButton;
